import React, { Component } from 'react';
import * as _ from 'lodash';
import PropTypes from 'prop-types';

import '../../../../app/assets/stylesheets/rte_edit_payer.scss';

class FormField extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    if (this.props.hidden) {
      return null;
    }
    return (
      <div className="FormField">
        {this.props.mode === 'edit' && this.props.editable && this.props.children}
        {(this.props.mode === 'view' || !this.props.editable) && this.props.renderViewMode()}
      </div>
    );
  }
}

FormField.propTypes = {
  mode:           PropTypes.string,
  children:       PropTypes.any,
  renderViewMode: PropTypes.func,
  editable:       PropTypes.bool,
  hidden:         PropTypes.bool
};

FormField.defaultProps = {
  renderViewMode: () => null,
  editable:       true,
  hidden:         false
};

export default FormField;
